import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalString,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createInvoiceInvoicingProductsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
        invoice_id: requiredUuid(),
        invoicing_product_id: requiredUuid(),
        quantity: requiredNumber(),
        name: optionalString(),
        price: optionalString(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
    });

export const createInvoiceInvoicingProductsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createInvoiceInvoicingProductsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.invoice_invoicing_products,
    );

export const createInvoiceInvoicingProductsDeleteSchema = () =>
    createDeleteSchema();

export const createInvoiceInvoicingProductsSchemas = () => ({
    add: createInvoiceInvoicingProductsAddSchema(),
    update: createInvoiceInvoicingProductsUpdateSchema(),
    delete: createInvoiceInvoicingProductsDeleteSchema(),
});
